import { Fetch } from 'lib';
import type { RoleSummary } from 'types';

type RequestResponses = {
  total: number;
  data: RoleSummary[];
};

type RequestParameters = {
  searchKey: string;
  pageSize: number;
  pageNumber: number;
};

const searchRoles = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminRole/searchRoles',
    params,
  });

export { searchRoles };
